module.exports = __webpack_public_path__ + "7b86511714c9ea8b5cd196b618778bb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Racers/racer_green.png
// module id = 652
// module chunks = 0